import { Route, RouteGroup } from '@billow/easy-route'
import { view } from '@/utilities/view'
import concat from 'lodash/concat'

export default RouteGroup({

  prefix: '/facility',

  routes: concat(
    [
      Route('/index', 'facilities', view('facility/Index')),
      Route('/create', 'facility.create', view('facility/Create')),
    ],

    RouteGroup({
      parent: Route('/:facility', '', view('facility/Edit')),
      routes: [
        Route('/', 'facility.edit', view('facility/edit/Info')),
        Route('pricing', 'facility.pricing', view('facility/edit/Pricing')),
        Route('extras', 'facility.extras', view('facility/edit/Extras'))
      ]
    })
  )
})